import React from 'react'
import { TextInput } from 'react-admin'
import { WithGetSource } from 'types/common'
import KToolTip from 'ui-shared/KTooltip'

type QuantityMultiplierProps = Partial<WithGetSource<'quantityMultiplier'>> & {
  disabled?: boolean
}

const QuantityMultiplier: React.FC<QuantityMultiplierProps> = ({
  getSource,
  disabled = false,
}) => (
  <KToolTip title={'tooltip.hint.quantityMultiplier'}>
    <TextInput
      label="form.fields.quantityMultiplier"
      source={getSource!('quantityMultiplier')}
      type="number"
      defaultValue={100}
      disabled={disabled}
    />
  </KToolTip>
)

export default QuantityMultiplier
